export const en = {
  resume: 'Resume',
  switch: 'Switch',
  reactivate: 'Reactivate',
  upgrade: 'Upgrade',
  downgrade: 'Downgrade',
  subscribe: 'Subscribe',
  usageExceeded: 'Usage Exceeded',
  currentPlan: 'Your Current Plan',
  perMonth: 'per month',
  perYear: 'per year',
  unlimitedUsers: 'Unlimited users',
  twoMonthsFree: 'Includes 2 Months Free.',
  threeMonthsFree: 'Includes 3 Months Free.',
  couponToBeApplied: 'Coupon to be applied',
  discountApplied: 'Discount applied',
  plusEverythingOnPremium: 'Plus everything on Premium',
  unlimitedGuests: 'Unlimited Clients',
  unlimitedProjects: 'Unlimited Projects',
  videoFeedback: 'Video Feedback',
  screenshotsExtension: 'Screenshots (requires Browser Extension)',
  storage10: '10 GB Storage',
  zapier: 'Zapier Integration',
  intergrations: 'Zapier, Slack, GitHub, Basecamp integrations',
  annotations: 'Annotations (via Browser Extension only)',
  publicFeedback: 'Public Feedback Widget',
  storage20: '20 GB Storage',
  plusStandard: 'Plus everything on Standard',
  screenshotsNoExtension: 'Screenshots (without a Browser Extension)',
  customBranding: 'Custom branding/logo',
  guestsSeeGuests: 'Clients can see other clients feedback',
  storage50: '50 GB Storage',
  membersComment: 'Members only comments',
  plusStudio: 'Plus everything on Studio',
  storage150: '150 GB Storage',
  customHeader: 'Custom',
  customMember: 'Min. 25 members',
  dedicatedSuccessManager: 'Dedicated Success Manager',
  onboardingAndTraining: 'Onboarding & training support',
  upltimeSla: '99.9% uptime SLA',
  plusPremium: 'Plus everything on Premium',
  customContactUs: 'Contact sales',
  singleSignOn: 'SSO (add on)',
  per: (price: number) => ` ($${price}/mo per additional user)`,
  creditCardRequired:
    "You'll need to enter payment details. Don't worry we won't charge your card for the free plan.",
  premiumIntegrations:
    'Premium integrations (Jira, Asana, Linear, ClickUp, Monday.com)',
  descriptionStandard: 'Ideal for freelancers and small teams.',
  descriptionStudio:
    'For growing agencies managing multiple client sites.',
  descriptionPremium:
    'For agencies that need integrations, white labelling, and enhanced client collaboration.',
  descriptionDeluxe:
    'Designed for enterprises with complex workflows and dedicated support needs.',
  descriptionCustom:
    'Designed for enterprises with complex workflows and dedicated support needs.'
};
export type Translations = typeof en;
